import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
var DocumentsNotIntegrationFormComponent = /** @class */ (function () {
    function DocumentsNotIntegrationFormComponent(errorsService, snackBar, formBuilder, route, authService, router) {
        this.errorsService = errorsService;
        this.snackBar = snackBar;
        this.formBuilder = formBuilder;
        this.route = route;
        this.authService = authService;
        this.router = router;
        this.customers = [];
    }
    DocumentsNotIntegrationFormComponent.prototype.ngOnInit = function () {
        this.id = this.route.snapshot.paramMap.get('id');
        this.formGroup = this.formBuilder.group({
            cpf: [null, [Validators.required]],
        });
        if (this.id) {
            this.findOne().catch(function (err) { return console.log(err); });
        }
    };
    DocumentsNotIntegrationFormComponent.prototype.findOne = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.authService.findOneDocumentsNotIntegration(this.id)
                            .then(function (response) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            return tslib_1.__generator(this, function (_a) {
                                this.formGroup.patchValue({
                                    cpf: response.cpf,
                                });
                                return [2 /*return*/];
                            });
                        }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    DocumentsNotIntegrationFormComponent.prototype.submit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var data;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                if (!this.formGroup.valid) {
                    this.snackBar.open('Preencha corretamente os campos e tente novamente.');
                    return [2 /*return*/, false];
                }
                data = {
                    cpf: this.formGroup.value.cpf,
                };
                if (this.id) {
                    this.authService.updateDocumentsNotIntegration(this.id, data).then(function (response) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                        return tslib_1.__generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!response) return [3 /*break*/, 2];
                                    return [4 /*yield*/, this.router.navigate(['./dashboard/documents-not-integration'])];
                                case 1:
                                    _a.sent();
                                    this.snackBar.open('CPF atualizada com sucesso.');
                                    _a.label = 2;
                                case 2: return [2 /*return*/];
                            }
                        });
                    }); }, function (error) {
                        _this.snackBar.open(error.error.message);
                    });
                }
                else {
                    this.authService.createDocumentsNotIntegration(data).then(function (response) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                        return tslib_1.__generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!response) return [3 /*break*/, 2];
                                    return [4 /*yield*/, this.router.navigate(['./dashboard/documents-not-integration'])];
                                case 1:
                                    _a.sent();
                                    this.snackBar.open('CPF cadastrado com sucesso.');
                                    _a.label = 2;
                                case 2: return [2 /*return*/];
                            }
                        });
                    }); }, function (error) {
                        _this.snackBar.open(error.error.message);
                    });
                }
                return [2 /*return*/];
            });
        });
    };
    return DocumentsNotIntegrationFormComponent;
}());
export { DocumentsNotIntegrationFormComponent };
